__turbopack_context__.v({
  "className": "agbalumo_d8d2bdb6-module__bzchlq__className",
});
